import script from "./TeacherAdvice.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherAdvice.vue?vue&type=script&setup=true&lang=js"

import "./TeacherAdvice.vue?vue&type=style&index=0&id=31219aed&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31219aed"]])

export default __exports__